import { render, staticRenderFns } from "./CrmTicketAdd.vue?vue&type=template&id=5f2fbfc1&"
import script from "./CrmTicketAdd.vue?vue&type=script&lang=js&"
export * from "./CrmTicketAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
